export const requiresFreshOfflinePaymentCode = (transactions = []) =>
  transactions.length === 0 ||
  transactions.some(({ payment_type: paymentType }) =>
    ["SPLIT_PAYMENT", "PART_PAYMENT"].includes(paymentType)
  );
